import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';

export const getCheckoutSession = async(preco) => {
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.post(`stripe/${preco}?ui=embedded`);
  return response.data.clientSecret;
};
export const getCustomerPortal = async() => {
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.post('stripe/customerPortal');
  return response.data.portalSession;
};
export const getSessionFromId = async(sessionId) => {
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`stripe/${sessionId}`);
  return response.data;
};
export const getAssinaturas = async() => {
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get('stripe');
  return response.data.data;
};
export const obterLicenca = async() => {
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get('licenca');
  return response.data;
};
